/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ResourceData from './ResourceData';

/**
 * The CampaignControllerDtoResourceUpdateRequest model module.
 * @module model/CampaignControllerDtoResourceUpdateRequest
 * @version 1.0
 */
class CampaignControllerDtoResourceUpdateRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoResourceUpdateRequest</code>.
     * @alias module:model/CampaignControllerDtoResourceUpdateRequest
     */
    constructor() { 
        
        CampaignControllerDtoResourceUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoResourceUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoResourceUpdateRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoResourceUpdateRequest} The populated <code>CampaignControllerDtoResourceUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoResourceUpdateRequest();

            if (data.hasOwnProperty('resources')) {
                obj['resources'] = ApiClient.convertToType(data['resources'], [ResourceData]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoResourceUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoResourceUpdateRequest</code>.
     */
    static validateJSON(data) {
        if (data['resources']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['resources'])) {
                throw new Error("Expected the field `resources` to be an array in the JSON data but got " + data['resources']);
            }
            // validate the optional field `resources` (array)
            for (const item of data['resources']) {
                ResourceData.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<module:model/ResourceData>} resources
 */
CampaignControllerDtoResourceUpdateRequest.prototype['resources'] = undefined;






export default CampaignControllerDtoResourceUpdateRequest;

